import React from 'react';

interface CharCountProps {
    current: number;
    max: number;
    error?: string | null;
    style?: React.CSSProperties; // 보통 너비 값(width)을 맞추기 위해 사용
}

/**
 * 작가 등록 및 작품 등록 등에서 공통으로 사용할 글자 수 카운터 컴포넌트
 */
const CharCount: React.FC<CharCountProps> = ({ current, max, error, style }) => {
    // 부모로부터 전달받은 스타일 중 너비(width)와 관련된 스타일만 적용하여 높이(height) 간섭 방지
    const containerStyle: React.CSSProperties = style ? { width: style.width, maxWidth: '100%' } : { width: '100%' };

    return (
        <div className="flex items-start justify-between mt-1" style={containerStyle}>
            {/* 좌측: 에러 메시지 (있는 경우) */}
            <div className="flex-1 min-w-0 mr-2">
                {error && <p className="font-namsan text-[12px] font-bold text-red-500 leading-tight">{error}</p>}
            </div>
            
            {/* 우측: 글자 수 카운트 */}
            <p className={`text-gray-600 text-[14px] font-namsan whitespace-nowrap ${current > max ? 'text-red-500 font-bold' : ''}`}>
                {current}/{max}
            </p>
        </div>
    );
};

export default CharCount;
